'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  font-size: ', ';\n'], ['\n  font-size: ', ';\n']);

var _underscore = require('underscore');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _immutable = require('immutable');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _autolinker = require('autolinker');

var _autolinker2 = _interopRequireDefault(_autolinker);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _UIIcon = require('UIComponents/icon/UIIcon');

var _UIIcon2 = _interopRequireDefault(_UIIcon);

var _KeyCodes = require('UIComponents/constants/KeyCodes');

var _UIIconButton = require('UIComponents/button/UIIconButton');

var _UIIconButton2 = _interopRequireDefault(_UIIconButton);

var _UIExpandingTextArea = require('UIComponents/input/UIExpandingTextArea');

var _UIExpandingTextArea2 = _interopRequireDefault(_UIExpandingTextArea);

var _UIFlex = require('UIComponents/layout/UIFlex');

var _UIFlex2 = _interopRequireDefault(_UIFlex);

var _UIBox = require('UIComponents/layout/UIBox');

var _UIBox2 = _interopRequireDefault(_UIBox);

var _UIFormControl = require('UIComponents/legacy/UIFormControl');

var _UIFormControl2 = _interopRequireDefault(_UIFormControl);

var _Defaults = require('conversations-schema/constants/Defaults');

var _getAccentColor = require('conversations-schema/operators/coloring/getAccentColor');

var _fileUploadGetters = require('conversations-internal-schema/file-upload/operators/fileUploadGetters');

var _isUploadCompleted = require('conversations-internal-schema/file-upload/operators/isUploadCompleted');

var _FileUpload = require('./attachments/FileUpload');

var _FileUpload2 = _interopRequireDefault(_FileUpload);

var _AttachmentPickerButton = require('./attachments/AttachmentPickerButton');

var _AttachmentPickerButton2 = _interopRequireDefault(_AttachmentPickerButton);

var _mobileConstants = require('./constants/mobileConstants');

var _RecordPropType = require('conversations-prop-types/prop-types/RecordPropType');

var _RecordPropType2 = _interopRequireDefault(_RecordPropType);

var _ChatWidgetLocaleContext = require('./ChatWidgetLocaleContext');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var IconStyles = _styledComponents2.default.span.withConfig({
  displayName: 'MessageEditor__IconStyles'
})(_templateObject, function (_ref) {
  var isMobile = _ref.isMobile;
  return isMobile ? _mobileConstants.mobileIconFontSize : undefined;
});

var MessageEditor = function (_Component) {
  _inherits(MessageEditor, _Component);

  function MessageEditor(props) {
    _classCallCheck(this, MessageEditor);

    var _this = _possibleConstructorReturn(this, (MessageEditor.__proto__ || Object.getPrototypeOf(MessageEditor)).call(this, props));

    _this.state = { messageText: '' };

    _this.handleChange = _this.handleChange.bind(_this);
    _this.handlePublish = _this.handlePublish.bind(_this);
    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
    _this.setEditorRef = _this.setEditorRef.bind(_this);
    _this.focusEditor = _this.focusEditor.bind(_this);
    _this.handleSelectAttachmentFiles = _this.handleSelectAttachmentFiles.bind(_this);
    _this.editorRef = null;
    return _this;
  }

  _createClass(MessageEditor, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.focusEditor();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!nextProps.disabled && this.props.disabled) {
        this.focusEditor();
      }
    }
  }, {
    key: 'focusEditor',
    value: function focusEditor() {
      var editorRef = this.editorRef;


      if (editorRef) {
        setTimeout(function () {
          editorRef.focus();
        });
      }
    }
  }, {
    key: 'getMessageText',
    value: function getMessageText() {
      var messageText = this.state.messageText;


      return messageText;
    }
  }, {
    key: 'messageTextIsWithinLimit',
    value: function messageTextIsWithinLimit() {
      return this.getMessageText().length < _Defaults.DEFAULT_MAX_MESSAGE_LENGTH;
    }
  }, {
    key: 'hasAttachments',
    value: function hasAttachments() {
      return this.props.stagedAttachments && this.props.stagedAttachments.size;
    }
  }, {
    key: 'attachmentsAreValid',
    value: function attachmentsAreValid() {
      if (!this.props.stagedAttachments) {
        return true;
      }

      return this.props.stagedAttachments.every(_isUploadCompleted.isUploadCompleted);
    }
  }, {
    key: 'canUploadAttachment',
    value: function canUploadAttachment() {
      if (this.props.hasUnansweredQuickReplyMessage) {
        return false;
      }

      if (this.props.supportsMultipleAttachments || !this.props.stagedAttachments) {
        return true;
      }

      return !this.props.stagedAttachments.size;
    }
  }, {
    key: 'messageContentsAreValid',
    value: function messageContentsAreValid() {
      return this.messageTextIsWithinLimit() && this.attachmentsAreValid() && (this.getMessageText() !== '' || this.hasAttachments());
    }
  }, {
    key: 'canPublish',
    value: function canPublish() {
      var _props = this.props,
          disabled = _props.disabled,
          networkOffline = _props.networkOffline;

      return this.messageContentsAreValid() && !networkOffline && !disabled;
    }
  }, {
    key: 'handleChange',
    value: function handleChange(e) {
      var chatInputChanged = this.props.chatInputChanged;

      this.setState({ messageText: e.target.value });
      if (this.getMessageText() !== '') {
        chatInputChanged();
      }
    }
  }, {
    key: 'handleKeyDown',
    value: function handleKeyDown(e) {
      if (e.keyCode === _KeyCodes.ENTER && e.shiftKey === false) {
        this.handlePublish();
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
      return true;
    }
  }, {
    key: 'handlePublish',
    value: function handlePublish() {
      if (this.canPublish()) {
        var messageText = this.getMessageText();
        this.props.publishMessage({
          text: messageText,
          richText: '<div>' + _autolinker2.default.link((0, _underscore.escape)(messageText)) + '</div>'
        });
        this.setState({ messageText: '' });

        this.focusEditor();
      }
    }
  }, {
    key: 'getSendButtonStyle',
    value: function getSendButtonStyle() {
      var _props$coloring = this.props.coloring,
          accentColor = _props$coloring.accentColor,
          useDefaultColor = _props$coloring.useDefaultColor;

      return !useDefaultColor ? { color: accentColor } : null;
    }
  }, {
    key: 'getValidationMessage',
    value: function getValidationMessage() {
      return !this.messageTextIsWithinLimit() ? _I18n2.default.text('conversationsUI.chatTextArea.validationMessage') : '';
    }
  }, {
    key: 'setEditorRef',
    value: function setEditorRef(component) {
      var node = _reactDom2.default.findDOMNode(component);

      this.editorRef = node;
    }
  }, {
    key: 'handleSelectAttachmentFiles',
    value: function handleSelectAttachmentFiles(_ref2) {
      var files = _ref2.files;

      this.props.onSelectAttachmentFiles({ files: files });

      this.focusEditor();
    }
  }, {
    key: 'renderTextInput',
    value: function renderTextInput() {
      var _this2 = this;

      var _props2 = this.props,
          disabled = _props2.disabled,
          showingHsBranding = _props2.showingHsBranding,
          networkOffline = _props2.networkOffline;
      var messageText = this.state.messageText;


      var className = (0, _classNames2.default)({
        'showing-branding': showingHsBranding
      });

      return _react2.default.createElement(
        _ChatWidgetLocaleContext.ChatWidgetLocaleContextConsumer,
        null,
        function (locale) {
          return _react2.default.createElement(
            _UIBox2.default,
            { grow: 0.95 },
            _react2.default.createElement(
              _UIFormControl2.default,
              {
                className: className,
                validationMessage: _this2.getValidationMessage(),
                error: !_this2.messageTextIsWithinLimit()
              },
              _react2.default.createElement(_UIExpandingTextArea2.default, {
                className: 'widget-textarea message-box',
                ref: _this2.setEditorRef,
                maxHeight: 100,
                placeholder: networkOffline ? _I18n2.default.text('conversationsUI.chatTextArea.offlinePlaceholder', { locale: locale }) : _I18n2.default.text('conversationsUI.chatTextArea.placeholder', {
                  locale: locale
                }),
                shrink: true,
                styled: false,
                resize: false,
                use: 'default',
                disabled: disabled || networkOffline,
                onChange: _this2.handleChange,
                onKeyDown: _this2.handleKeyDown,
                error: !_this2.messageTextIsWithinLimit(),
                value: messageText
              })
            )
          );
        }
      );
    }
  }, {
    key: 'renderFileUploads',
    value: function renderFileUploads() {
      var _this3 = this;

      if (!this.props.stagedAttachments || !this.props.stagedAttachments.size) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        {
          className: (0, _classNames2.default)('m-bottom-2', {
            'm-top-2': this.props.showingHsBranding
          })
        },
        this.props.stagedAttachments.map(function (attachment) {
          return _react2.default.createElement(_FileUpload2.default, {
            key: (0, _fileUploadGetters.getLocalId)(attachment),
            attachment: attachment,
            onRemove: function onRemove() {
              _this3.props.onRemoveAttachment({ attachment: attachment });
            }
          });
        })
      );
    }
  }, {
    key: 'renderAttachmentButton',
    value: function renderAttachmentButton() {
      if (!this.props.supportsAttachments) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { className: (0, _classNames2.default)({ 'm-right-3': this.props.mobile }) },
        _react2.default.createElement(_AttachmentPickerButton2.default, {
          allowMultiple: this.props.supportsMultipleAttachments,
          color: (0, _getAccentColor.getAccentColor)(this.props.coloring),
          disabled: !this.canUploadAttachment(),
          mobile: this.props.mobile,
          onClick: this.props.onAttachmentButtonClick,
          onSelectFiles: this.handleSelectAttachmentFiles,
          maxAttachmentFileSize: this.props.maxAttachmentFileSize
        })
      );
    }
  }, {
    key: 'renderSendButton',
    value: function renderSendButton() {
      return _react2.default.createElement(
        _UIIconButton2.default,
        {
          className: 'chat-send-button',
          color: (0, _getAccentColor.getAccentColor)(this.props.coloring),
          disabled: !this.canPublish(),
          use: 'link',
          onClick: this.handlePublish,
          style: this.getSendButtonStyle()
        },
        _react2.default.createElement(
          IconStyles,
          { isMobile: this.props.mobile },
          _react2.default.createElement(_UIIcon2.default, { name: 'send' })
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _UIFlex2.default,
        { direction: 'column', justify: 'between', wrap: 'nowrap' },
        _react2.default.createElement(
          'div',
          { className: 'width-100' },
          this.renderFileUploads()
        ),
        _react2.default.createElement(
          _UIFlex2.default,
          {
            className: 'width-100',
            align: 'center',
            justify: 'between',
            wrap: 'nowrap'
          },
          this.renderTextInput(),
          _react2.default.createElement(
            'div',
            { className: 'display-flex flex-row m-left-1' },
            this.renderAttachmentButton(),
            this.renderSendButton()
          )
        )
      );
    }
  }]);

  return MessageEditor;
}(_react.Component);

MessageEditor.propTypes = {
  chatInputChanged: _react.PropTypes.func.isRequired,
  coloring: (0, _RecordPropType2.default)('ColoringRecord'),
  disabled: _react.PropTypes.bool.isRequired,
  hasUnansweredQuickReplyMessage: _react.PropTypes.bool.isRequired,
  maxAttachmentFileSize: _react.PropTypes.number.isRequired,
  mobile: _react.PropTypes.bool,
  networkOffline: _react.PropTypes.bool.isRequired,
  onAttachmentButtonClick: _react.PropTypes.func,
  onRemoveAttachment: _react.PropTypes.func.isRequired,
  onSelectAttachmentFiles: _react.PropTypes.func.isRequired,
  publishMessage: _react.PropTypes.func.isRequired,
  showingHsBranding: _react.PropTypes.bool,
  stagedAttachments: _react.PropTypes.instanceOf(_immutable.List),
  supportsAttachments: _react.PropTypes.bool.isRequired,
  supportsMultipleAttachments: _react.PropTypes.bool
};

MessageEditor.defaultProps = {
  onRemoveAttachment: function onRemoveAttachment() {},
  onSelectAttachmentFiles: function onSelectAttachmentFiles() {},
  supportsAttachments: false,
  supportsMultipleAttachments: false,
  hasUnansweredQuickReplyMessage: false
};

exports.default = MessageEditor;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-components/static-1.4266/js/visitor-widget/MessageEditor.js
// module id = 1153
// module chunks = 2 3